import { render, staticRenderFns } from "./PlantContributorPopup.vue?vue&type=template&id=3158a488"
import script from "./PlantContributorPopup.vue?vue&type=script&lang=js"
export * from "./PlantContributorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports